import React, { useState, useEffect, useRef } from 'react';

type MarqueeSpeed = 'slow' | 'medium' | 'fast';

function UAEMarquee({ showMarquee = true, speed = 'slow' as MarqueeSpeed }) {
  const [isVisible, setIsVisible] = useState(showMarquee || false);
  const marqueeRef = useRef<HTMLDivElement>(null);
  const speedMapping: Record<MarqueeSpeed, number> = {
    slow: 30,
    medium: 60,
    fast: 90,
  };

  useEffect(() => {
    if (!isVisible || !marqueeRef.current) return;

    const marqueeContainer = marqueeRef.current;
    const marqueeContent = marqueeContainer.firstChild as HTMLDivElement;
    let animationFrameId: number;
    let startTime: number;
    let position = marqueeContainer.offsetWidth;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;

      position =
        0 - (elapsed * speedMapping[speed]) / 700;

      if (position < -marqueeContent.offsetWidth) {
        position = marqueeContainer.offsetWidth;
        startTime = timestamp;
      }

      marqueeContent.style.transform = `translateX(${position}px)`;

      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isVisible, speed]);

  useEffect(() => {
    setIsVisible(showMarquee);
  }, [showMarquee]);

  if (!isVisible) return null;

  return (
    <div
      className="w-full bg-[#000] overflow-hidden py-2 border-b border-black"
      ref={marqueeRef}
    >
      <div className="flex items-center whitespace-nowrap">
        {Array.from({ length: 1000 }, (_, index) => (
          <React.Fragment key={index}>
            <span className="font-medium golden-text-main mr-2">
              Pixa is now available in Arabic
            </span>
            <img
              src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1744042279/UAE/hhhjjekvvkb2ij9e5ooa.png"
              alt="UAE Flag"
              className="h-3 w-4 mx-4"
            />
            <span
              className="font-[600] text-base leading-normal golden-text-main mr-12"
              dir="rtl"
            >
              بيكسا متاح الآن باللغة العربية!
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default UAEMarquee;
